import gql from 'graphql-tag'

export const CONTACT_RELATIONSHIP_DELETE_MUTATION = gql`
    mutation contactRelationshipDelete(
        $id: ID!
    ) {
        contactRelationshipDelete(
            id: $id
        ) {
            status
        }
    }
`
